<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <div ref="contianer" class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header"></div>
      <div>
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[0, 0]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :ref="'grid_' + item.i" v-bind:is="item.i" :monitorSetting="monitorSetting"></component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';
import andeng_count from '@@/pages/web/customize/yongxin/monitor/mes/andeng/andeng_count';
import andeng_wait_handle from '@@/pages/web/customize/yongxin/monitor/mes/andeng/andeng_wait_handle';
import andeng_wait_confirm from '@@/pages/web/customize/yongxin/monitor/mes/andeng/andeng_wait_confirm';

export default {
  name: 'web_customize_yongxin_monitor_mes_andeng_index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    andeng_wait_handle: andeng_wait_handle,
    andeng_wait_confirm: andeng_wait_confirm,
    andeng_count: andeng_count
  },

  data() {
    return {
      monitorSetting: {},
      isShowBoardEdit: false,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: []
    };
  },
  created() {
    this.monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING'));

    this.setLayout();
    this.utils.event_hub.$emit('TOGGLE_TABBAR', true);
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() { },
  methods: {
    setLayout() {
      this.layout = [
        {
          x: 0,
          y: 0,
          w: 24,
          h: 4, //应该是6
          i: 'andeng_count'
        },

        {
          x: 0,
          y: 2,
          w: 12,
          h: 20, //应该是6
          i: 'andeng_wait_confirm'
        },
        {
          x: 12,
          y: 2,
          w: 12,
          h: 20, //应该是6
          i: 'andeng_wait_handle'
        }
      ];
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.$refs.contianer.offsetHeight;
        this.gridRowHeihgt = this.gridContainerHeight / 24;
      }, 500);
    }
  }
};
</script>
